import { render, staticRenderFns } from "./toppodpisokk.vue?vue&type=template&id=933520f4&"
import script from "./toppodpisokk.vue?vue&type=script&lang=js&"
export * from "./toppodpisokk.vue?vue&type=script&lang=js&"
import style0 from "./toppodpisokk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports